import { MfNode } from "../node/MfNode";
import { findByExpr } from "./findByExpr";

export const calcExprValue = (
  expr: string,
  srcNode: MfNode,
  root: MfNode,
): unknown => {
  const res = findByExpr(expr, srcNode, root);
  if (!res) return undefined;
  const { suffix } = res;
  const { value, title } = res.node;
  if (suffix) {
    if (suffix === "title") {
      return title;
    }
    if (value && typeof value === "object" && suffix in value) {
      return (value as Record<string, unknown>)[suffix];
    }
  }
  return value;
};
